import { api } from './apiClient';

/**
 * Inventory Command Center / item-360 / warehouse-360 / reorder / expiry client.
 * Backed by /inventory-command (migration 062), which reuses the existing
 * costing/availability engine. apiClient auto-unwraps {status,data}.
 */
export const inventoryCommandService = {
  commandCenter: (): Promise<Record<string, any>> => api.get('/inventory-command/command-center'),
  item360: (productId: number): Promise<Record<string, any>> => api.get(`/inventory-command/item/${productId}/360`),
  warehouse360: (warehouseId: number): Promise<Record<string, any>> =>
    api.get(`/inventory-command/warehouse/${warehouseId}/360`),
  reorder: (): Promise<{ worklist: any[]; count: number }> => api.get('/inventory-command/reorder'),
  expiry: (): Promise<{ buckets: Record<string, { count: number; value: number; items: any[] }> }> =>
    api.get('/inventory-command/expiry'),
  analytics: (): Promise<{ ageing: any; deadStock: any; abc: any; reorder: any }> =>
    api.get('/inventory-command/analytics'),
};

export default inventoryCommandService;
